export default __webpack_public_path__ + "static/media/desktop.fe6bd759.svg";